import {
    isLoggedInFromCenter,
    isManagingAccount as testIfIsManagingAccount,
} from 'ff/common/system';
import getStandaloneHost from 'ff/common/components/getStandaloneHost';
import { RenderMenuParams } from 'ff/common/components/FFMenuV2/RenderMenuParams';

export function renderBanner(params: RenderMenuParams) {
    const currentUser = params?.currentUser || window.currentUser;
    const isManagingAnAccount = testIfIsManagingAccount(currentUser);
    const loggedInFromCenter = isLoggedInFromCenter(params.serverEnv);
    if (loggedInFromCenter || isManagingAnAccount) {
        const host = getStandaloneHost() || '';
        const exitUrl =
            host +
            (loggedInFromCenter
                ? '/auth/api/logout'
                : '/account/2/manage-account/logout');

        const root = document.getElementById('ffweb-managing-account-banner');
        if (!root) {
            console.log('manage account banner root not found');
            return;
        }
        let shadowRoot;
        if (root.shadowRoot) {
            //If the menu is rerendered and there is already a shadow root, clear it and use it to fill up again
            root.shadowRoot.innerHTML = '';
            shadowRoot = root.shadowRoot;
        } else {
            //Shadow root lets us add styles that are isolated from the rest of the dom. DOM styles won't
            // affect anything in the shadow root, and styles in the shadow root wont affect the rest of the DOM
            shadowRoot = root.attachShadow({ mode: 'open' });
        }

        const style = document.createElement('style');

        style.textContent = `
            .manage-account-banner {
                background: #3498DB;
                color: #FFF;
                display: flex;
                justify-content: center;
                align-items: center;
                flex: 0 0 26px;
                position: relative;
                height: 25px;
                font-size: 13px;
                font-family:  "Helvetica Neue", "Helvetica", "proxima-nova", sans-serif;
            }

            .manage-account-banner a {
                padding: 0 10px 0 14px;
                display: flex;
                align-items: center;
                line-height: 1;
                color: #fff;
                font-weight: 400;
                background: transparent;
                text-decoration: underline;
                transition: ease .5s background;
            }
            .manage-account-banner a:hover {
                background: rgba(255,255,255,.07);
                color: #FFF;
            }
            .manage-account-banner a:active {
                box-shadow: 0 0px 8px 0 rgba(0,0,0,.1) inset;
                background: rgba(0,0,0,.14);
                transition: ease-out .05s background;
            }
            .manage-account-banner a i {
                margin-left: 3px;
            }
      `;
        shadowRoot.appendChild(style);

        const accountBanner = document.createElement('div');
        accountBanner.classList.add('manage-account-banner');
        shadowRoot.appendChild(accountBanner);

        const username = currentUser.managedUsername || currentUser.username;
        const mainText = document.createElement('span');
        if (username)
            //Not sure how you could get to this point without a username, but to be defensive
            mainText.innerHTML = `You are currently managing the account <strong>${username}</strong>`;
        else mainText.innerHTML = `You are currently managing an account`;
        accountBanner.appendChild(mainText);

        const linkTag = document.createElement('a');
        linkTag.setAttribute('href', exitUrl);
        linkTag.text = 'Exit this account';
        accountBanner.appendChild(linkTag);
    } else {
        const root = document.getElementById('ffweb-managing-account-banner');
        if (root?.shadowRoot) {
            root.shadowRoot.innerHTML = '';
        }
    }
}
